export const environmentalLawConst = {
  path: "/single-programs/environmental-law",
  title: "ФАКУЛЬТЕТ ПРАВА — ЭКОЛОГИЧЕСКОЕ ПРАВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Экологическое право — защита природы с юридической точностью</h2>
      <p>
        Экологическое право — это быстро развивающееся направление, формирующее новую волну специалистов, способных защищать окружающую
        среду и обеспечивать устойчивое развитие. Программа объединяет правовую подготовку и знания в области экологии, климата и
        природопользования.
      </p>
      <p>
        Это идеальный выбор для тех, кто хочет влиять на политику в области охраны природы, работать в международных организациях,
        ESG-консалтинге или юридических структурах, специализирующихся на экоправах.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Международное и европейское экологическое право</li>
        <li>Законодательство об охране окружающей среды</li>
        <li>Климатические соглашения и устойчивое развитие</li>
        <li>Ответственность за экологические правонарушения</li>
        <li>Экологическая экспертиза и правовое сопровождение проектов</li>
        <li>ESG (экологические, социальные и управленческие стандарты)</li>
        <li>Воздействие промышленности на природу: правовые ограничения</li>
        <li>Эко-комплаенс и корпоративная экологическая ответственность</li>
      </ul>
      <p>
        Программа включает анализ реальных кейсов, моделирование судебных разбирательств, экологические аудиты и проекты устойчивого
        развития.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Юрист по экологическому праву</li>
        <li>Консультант по устойчивому развитию и ESG</li>
        <li>Специалист по экопроектам в корпорациях</li>
        <li>Эксперт в экологических НКО или международных организациях</li>
        <li>Аналитик правовых рисков в природоохранной сфере</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €90,000 в год</strong> — особенно востребованы специалисты с ESG-компетенциями и знанием международных норм.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, соответствующий требованиям ЕС</li>
        <li>Программа доступна на русском и английском языках</li>
        <li>Гибкий формат: очно или дистанционно</li>
        <li>Практика на стыке права и экологии</li>
        <li>Поддержка в поиске стажировок и карьерного пути</li>
        <li>Актуальные ESG-навыки и доступ к международным экологическим платформам</li>
      </ul>
      <p>Экологическое право — профессия, которая работает ради будущего планеты.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам на каждом этапе — от подачи заявки до начала учёбы.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Экологическое право — защита природы с юридической точностью
    Экологическое право — это быстро развивающееся направление, формирующее новую волну специалистов, способных защищать окружающую среду и обеспечивать устойчивое развитие. Программа объединяет правовую подготовку и знания в области экологии, климата и природопользования.
    Это идеальный выбор для тех, кто хочет влиять на политику в области охраны природы, работать в международных организациях, ESG-консалтинге или юридических структурах, специализирующихся на экоправах.
    Что вы будете изучать?
    • Международное и европейское экологическое право
    • Законодательство об охране окружающей среды
    • Климатические соглашения и устойчивое развитие
    • Ответственность за экологические правонарушения
    • Экологическая экспертиза и правовое сопровождение проектов
    • ESG (экологические, социальные и управленческие стандарты)
    • Воздействие промышленности на природу: правовые ограничения
    • Эко-комплаенс и корпоративная экологическая ответственность
    Программа включает анализ реальных кейсов, моделирование судебных разбирательств, экологические аудиты и проекты устойчивого развития.
    Кем можно работать после окончания?
    • Юрист по экологическому праву
    • Консультант по устойчивому развитию и ESG
    • Специалист по экопроектам в корпорациях
    • Эксперт в экологических НКО или международных организациях
    • Аналитик правовых рисков в природоохранной сфере
    Зарплата в Европе: от €50,000 до €90,000 в год — особенно востребованы специалисты с ESG-компетенциями и знанием международных норм.
    Почему выбирают нас?
    • Европейский диплом, соответствующий требованиям ЕС
    • Программа доступна на русском и английском языках
    • Гибкий формат: очно или дистанционно
    • Практика на стыке права и экологии
    • Поддержка в поиске стажировок и карьерного пути
    • Актуальные ESG-навыки и доступ к международным экологическим платформам
    Экологическое право — профессия, которая работает ради будущего планеты.
    Как поступить?
    Приёмная комиссия поможет вам на каждом этапе — от подачи заявки до начала учёбы.
  `,
};
